import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {URL_IMG} from '../../../configs/urlConfigs';
import {MSG_REQUIRED, MSG_NOT_FOUND, MSG_SECTOR_ADD_SUCCESS, MSG_SECTOR_UPDATE_SUCCESS, MSG_SECTOR_DELETE_SUCCESS, MSG_SECTOR_DELETE_424_ERROR} from '../../../configs/msgConfigs';
import { LBL_APP_NAME, LBL_SETTINGS, LBL_SECTORS, LBL_ACTIONS,LBL_CONFIRM_DELETE, LBL_ADD_NEW, LBL_BACK_TO_SETTINGS} from '../../../configs/labelConfigs';
import {ROUTE_REFRESH, ROUTE_SA_SETTINGS} from '../../../configs/staticConfigs';
import * as types from '../../../actions';

 
import ModalWindow from '../../commons/helpers/modalWindow';
import Toast from '../../commons/helpers/toast';

import {formValid} from '../../../utils/validation';
import {getSortClass} from '../../../utils/commonUtilities'; 

import {sectorListAction, sectorAddAction, sectorEditAction, sectorUpdateAction, sectorDeleteAction} from '../../../actions/settings/superadmin/sectorActions';
import {clearAction} from '../../../actions/commonActions';

class SectorsComponent extends Component { 

    constructor(props){
        super()

        this.state = {
            activeRowId:0,            
            formErrors:{
                sectorName: "",
            },          
            sectorData:{
                sectorId:0,
                sectorName: null,               
            },
            sortField:'name',
            sortOrder:'',
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
        }

        this.openModal = this.openModal.bind(this);
        this.onSaveFormData = this.onSaveFormData.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        this.onSort = this.onSort.bind(this);
        this.modalDelete = React.createRef();
        this.modal = React.createRef();
    }
  
    openModal() {
        let formErrors = this.state.formErrors;
        formErrors.sectorName = '';
        this.setState({formErrors});
        this.modal.current.handleOpenModal();

    }  

    onModalFormReset = () =>{   
        let sectorData   = this.state.sectorData;     
        sectorData.sectorId = '';
        sectorData.sectorName = null;         
        this.setState(sectorData);   
    }

    onHandleChange = (event) =>{
        const {name, value} = event.target;

        let formErrors     = this.state.formErrors;
        let trimmedValue   = value.trim();
        switch(name){
            case 'sectorName':
                formErrors.sectorName = 
                trimmedValue.length <=0
                ? MSG_REQUIRED
                : ""
                break;            
            default :
            break;
        }

        let sectorData   = this.state.sectorData;
        sectorData[name] = value;

        this.setState({formErrors,sectorData});

    }    

    onShowActionButtons = (event, rowId) =>{

        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');      

        if(this.state.activeRowId===0){   
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus();
        }
        else if(this.state.activeRowId===rowId){ 
            this.setState({activeRowId:0}); 
        }
        else if(this.state.activeRowId!==rowId){   
            dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus();
        } 
    }   
    
    onHideActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({activeRowId:0});
    }

    onSaveFormData = (id) =>{
        if(formValid(this.state)){ 
            let formErrors = this.state.formErrors;  
            if(id){              
                let sectorData= {
                    id:id,
                    name: this.state.sectorData.sectorName,                      
                } 
                this.props.sectorUpdateAction(sectorData);  
            }else{                
                let sectorData= {
                    name: this.state.sectorData.sectorName,                      
                } 
                this.props.sectorAddAction(sectorData);          
            }  
            this.setState({formErrors});  
           
        }else{
            let formErrors = this.state.formErrors;
            if(this.state.sectorData.sectorName==null){
                formErrors.sectorName = MSG_REQUIRED;
            }            
            this.setState({formErrors});
        }
    }

    editBtnClick = (rowId) =>{  
        let formErrors = this.state.formErrors;
        formErrors.sectorName = '';
        this.setState(formErrors);
        this.modal.current.handleOpenModal();
        this.props.sectorEditAction(rowId);
    }

    deleteBtnClick = (rowId,name) =>{
        this.setState({
            sectorData: {
                sectorId: rowId,  
                sectorName:name             
            }
        }); 
        this.modalDelete.current.handleOpenModal();
    }

    onDeleteAction = () =>{
        let sectorId = this.state.sectorData.sectorId;
        this.props.sectorDeleteAction(sectorId);
        this.modalDelete.current.handleModelClose();              
    }

    onSort = (event,sortKey) =>{        
        let sOrder = '';
        if(this.state.sortField===sortKey){         
            sOrder = (this.state.sortOrder==='-') ? '' : '-';
            this.props.sectorListAction({column:sOrder+this.state.sortField});
            this.setState({ sortOrder:sOrder });            
        }else{
            this.setState({ sortField:sortKey });
            this.props.sectorListAction({column:this.state.sortOrder+sortKey});
        }        
    }
    
    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    }    

    setToasterState(isEnabled,message,isSucces){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        setTimeout(()=> {
            this.onCloseToast();
        }, 4000);
    }

    setStateUpdate(sector,status,activity,errorData){
        let formErrors = this.state.formErrors;
        if(activity===types.SECTOR_ADD_SUPERADMIN_SUCCESS){
            this.modal.current.handleModelClose();
            this.props.sectorListAction({column:this.state.sortOrder+this.state.sortField});
            this.setToasterState(true,MSG_SECTOR_ADD_SUCCESS,true);
        }else if(activity===types.SECTOR_ADD_SUPERADMIN_ERROR){
            if(status===400){
                if(errorData.hasOwnProperty('name')){ 
                    formErrors.sectorName = errorData.name[0];
                }else{
                    this.modal.current.handleModelClose();
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }
                this.setState(formErrors); 
            }else{
                this.modal.current.handleModelClose();
                if(errorData.hasOwnProperty('message')){ 
                    this.setToasterState(true,errorData.message,false);
                }else{
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }   
            } 
        }else if(activity===types.SECTOR_UPDATE_SUPERADMIN_SUCCESS){
            this.modal.current.handleModelClose();
            this.setToasterState(true,MSG_SECTOR_UPDATE_SUCCESS,true);  
        }else if(activity===types.SECTOR_UPDATE_SUPERADMIN_ERROR){ 
            if(status===400){
                if(errorData.hasOwnProperty('name')){ 
                    formErrors.sectorName = errorData.name[0];
                }else{
                    this.modal.current.handleModelClose();
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }
                this.setState(formErrors); 
            }else{
                this.modal.current.handleModelClose();
                if(errorData.hasOwnProperty('message')){ 
                    this.setToasterState(true,errorData.message,false);
                }else{
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }   
            } 
        }else if(activity===types.SECTOR_EDIT_SUPERADMIN_SUCCESS){    
            this.setState({
                sectorData:{
                    sectorId:sector.id,
                    sectorName:sector.name
                }
            }, () => {
                if(document.getElementById('sectorName')) {
                    document.getElementById('sectorName').focus(); 
                }
            });
        }else if(activity===types.SECTOR_DELETE_SUPERADMIN_SUCCESS){
            this.props.sectorListAction({column:this.state.sortOrder+this.state.sortField});
            this.setToasterState(true,MSG_SECTOR_DELETE_SUCCESS,true); 
        }else if(activity===types.SECTOR_DELETE_SUPERADMIN_ERROR){
            let errMsg = ''; 
            if(status===424) errMsg = MSG_SECTOR_DELETE_424_ERROR; 
            else {
                errMsg = errorData.message ? JSON.stringify(errorData.message) : JSON.stringify(errorData);
            }
            this.setToasterState(true,errMsg,false);
        }
    }

    componentDidUpdate(prevProps) {       
        const { sector,status,activity,errorData} = this.props;
        if (activity !== prevProps.activity) {
            this.setStateUpdate(sector,status,activity,errorData);
            this.props.clearAction();
        }        
    }

    componentDidMount() {        
        this.props.sectorListAction({page:this.state.activePage,column:this.state.sortOrder+this.state.sortField});    
        document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+" -  "+LBL_SECTORS;
    }    
       
    render(){

        const {
            toastMessage,toastFlag,toastSuccess,sectorData,sortField,sortOrder,          
        } = this.state

        const { sectors,status} = this.props;     
        
        if(status===401 || status===403){
            return <Redirect to={ROUTE_REFRESH} />;
        }

        return(
            <div className="col-md-8">             
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} /> 
                <div className="box">
                    <div className="box-head">
                        <div className='divFloatLeft padding-left-20 padding-top-5 font-14'><Link to={ROUTE_SA_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link></div>
                        <div className="to-right">                                   
                            <button className="btn btn-primary launch-modal" onClick={this.openModal}>{LBL_ADD_NEW}</button>
                        </div>
                    </div>
                    <div className="box-content">
                        <div className="table-responsive">
                            <table id="sector-data-table" className="table" style={{width:"100%"}}>
                                <thead>                                  
                                    <tr>
                                        <th>#</th>
                                        <th onClick={(e) => this.onSort(e,'name')} className="spanPointer">{LBL_SECTORS} <i className={sortField=='name' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                        <th>{LBL_ACTIONS}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {(this.props.count===0) && 
 
                                    <tr>
                                        <td colSpan="6" className="text-center">{MSG_NOT_FOUND}</td>
                                    </tr>
                                }
                                {sectors.map((item,index) => {
                                    return (
                                        <tr key={item.id}>
                                            <td>{index+1}</td>
                                            <td>{item.name}</td>
                                            <td>
                                            <div className="dropdown" id={'dropdown-'+item.id}>
                                                <button className="dropdown-toggle" type="button"
                                                    id={'dropdownMenuButton-'+item.id} data-toggle="dropdown"
                                                    aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)}
                                                    >
                                                    <input type="image" id={"img-action-"+item.id} src={require('../../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                </button>
                                                <div className="dropdown-menu" id={'dropdown-menu-'+item.id}
                                                    aria-labelledby={'dropdownMenuButton-'+item.id}>
                                                    <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(item.id)}>Edit</Link>
                                                    <Link className="dropdown-item delete"
                                                        to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.name)}>Delete</Link>
                                                </div>
                                            </div>
                                            </td>
                                        </tr>             
                                        
                                     )
                                  })      

                                }                          
                                </tbody>
                            </table>
                            <div className="clear-b-scroll-sector">&nbsp;</div>
                            <div className="clear-b-scroll-sector">&nbsp;</div>
                        </div>
                    </div>
                </div>

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                {"Are you sure you want to delete sector '"+sectorData.sectorName+"'?"}
                </ModalWindow>


                <ModalWindow ref={this.modal} header={Number(this.state.sectorData.sectorId) > 0 ? "Edit Sector" : "Add Sector"} saveFormData={ (e)=>this.onSaveFormData(sectorData.sectorId)} resetModalForm={this.onModalFormReset}  autoFocusField='sectorName'>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Sector</label>
                                <div className="text-input">
                                    <input type="text" className={this.state.formErrors.sectorName.length >0 ? "input-error" : ''} name="sectorName" id="sectorName" value={sectorData.sectorName || ''} onChange={this.onHandleChange} placeholder="" maxLength = {120} />
                                    {this.state.formErrors.sectorName.length >0 && (
                                        <div className="text-red left-align text-12">{this.state.formErrors.sectorName}</div>
                                    )} 
                                    </div>
                            </div>
                        </div>
                    </div>
                </ModalWindow>
            </div>
        )
        
    }
    
}

const mapStateToProps = (state) => {
    return {
        sectors : state.sectors.items,
        sector:state.sectors.item,
        status:state.sectors.status,
        activity:state.sectors.activity,
        count:state.sectors.count,
        errorData:state.sectors.errorData
    }
}
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        sectorListAction:sectorListAction,  
        sectorAddAction:data=>sectorAddAction(data),
        sectorEditAction:id=>sectorEditAction(id),
        sectorUpdateAction:data=>sectorUpdateAction(data),
        sectorDeleteAction:id=>sectorDeleteAction(id),
        clearAction:clearAction
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(SectorsComponent);